import pathname, { menuType } from '../../../constants/pathname'

export const subProjectReportSchema = {
  alwaysOpenKeys: ['1', '2', '3', '4'],
  menu: menuType.subProjectReport,
  sidebars: [
    {
      id: 'section9',
      type: 'nav',
      items: [
        {
          eventKey: '9-1',
          icon: {
            name: 'sitemap',
          },
          link: pathname.subProject.subProjectPage,
          children: 'จัดการโครงการย่อย',
        },
        {
          eventKey: '9-2',
          icon: {
            name: 'search',
          },
          link: pathname.subProject.searchSubproject,
          children: 'ค้นหาข้อมูลโครงการย่อย',
        },
        {
          eventKey: '9-3',
          icon: {
            name: 'file-text-o',
          },
          link: pathname.subProject.projectIndicators,
          children: 'รายงานตัวชี้วัดโครงการ',
        },
        {
          eventKey: '9-4',
          icon: {
            name: 'file-text-o',
          },
          link: pathname.subProject.checkProjectQuality,
          children: 'รายการตรวขสอบคุณภาพโครงการย่อย',
        },
      ],
    },

    // {
    //   id: 'section1',
    //   type: 'dropdown',
    //   titleItem: {
    //     eventKey: '1',
    //     placement: 'rightStart',
    //     title: 'รายงาน',
    //     icon: 'file-text-o',
    //   },
    //   items: [
    //     {
    //       eventKey: '1-1',
    //       icon: {
    //         name: 'check-circle',
    //       },
    //       link: pathname.subProject.report.approvalFormReport,
    //       children: 'แบบขออนุมัติโครงการ',
    //     },
    //     {
    //       eventKey: '1-2',
    //       icon: {
    //         name: 'check-circle',
    //       },
    //       link: pathname.subProject.report.summaryReport,
    //       children: 'รายงานสรุปเพื่อขออนุมัติ',
    //     },
    //     {
    //       eventKey: '1-3',
    //       icon: {
    //         name: 'check-circle',
    //       },
    //       link: pathname.subProject.report.grantReport,
    //       children: 'สัญญารับทุน',
    //     },
    //     {
    //       eventKey: '1-4',
    //       icon: {
    //         name: 'check-circle',
    //       },
    //       link: pathname.subProject.report.billPaymentReport,
    //       children: 'ใบเบิกเงินโครงการย่อย',
    //     },
    //     {
    //       eventKey: '1-5',
    //       icon: {
    //         name: 'check-circle',
    //       },
    //       link: pathname.subProject.report.subProjectApprovalReport,
    //       children: 'ขออนุมัติปิดโครงกาารย่อย',
    //     },
    //     {
    //       eventKey: '1-6',
    //       icon: {
    //         name: 'check-circle',
    //       },
    //       link: pathname.subProject.report.progressiveReport,
    //       children: 'แบบรายงานความก้าวหน้าโครงการ',
    //     },
    //     {
    //       eventKey: '1-7',
    //       icon: {
    //         name: 'check-circle',
    //       },
    //       link: pathname.subProject.report.projectControlReport,
    //       children: 'ทะเบียนควบคุมโครงการ',
    //     },
    //     {
    //       eventKey: '1-7',
    //       icon: {
    //         name: 'check-circle',
    //       },
    //       link: pathname.subProject.report.subProjectReport,
    //       children: 'รายงานโครงการย่อย',
    //     },
    //   ],
    // },
    {
      id: 'section2',
      type: 'dropdown',
      titleItem: {
        eventKey: '2',
        placement: 'rightStart',
        title: 'ตั้งค่าการใช้งาน',
        icon: 'gear',
      },
      items: [
        // {
        //   eventKey: '2-1',
        //   icon: {
        //     name: 'check-circle',
        //   },
        //   link: pathname.subProject.users.createUser,
        //   children: 'ผู้ใช้งาน',
        // },
        // {
        //   eventKey: '2-2',
        //   icon: {
        //     name: 'check-circle',
        //   },
        //   link: pathname.subProject.setting.reportSetting,
        //   children: 'ตั้งค่ารายงาน',
        // },
        {
          eventKey: '2-3',
          icon: {
            name: 'check-circle',
          },
          link: pathname.subProjectNew.settingProposal.templeteManage,
          children: 'ตั้งค่า Templete โครงการย่อย',
        },
      ],
    },
    {
      id: 'ROLE_MANAGE_MENU',
      type: 'dropdown',
      remark: null,
      numberOfStep: 0,
      currentStep: 0,
      menuSeq: 300,
      items: [
        {
          eventKey: 'ROLE_MANAGE_MENU_9_1_1',
          icon: { name: 'wrench', color: '' },
          link: '/proposal-subproject/manage-user-groups',
          children: 'จัดการกลุ่มผู้ใช้งาน',
          param: '',
          paramName: '',
          isDisabled: false,
          viewMode: false,
          feedback: false,
        },
        {
          eventKey: 'ROLE_MANAGE_MENU_9_1_2',
          icon: { name: 'wrench', color: '' },
          link: '/proposal-subproject/manage-user-role',
          children: 'จัดการสิทธิ์โครงการย่อย',
          param: '',
          paramName: '',
          isDisabled: false,
          viewMode: false,
          feedback: false,
        },
        {
          eventKey: 'ROLE_MANAGE_MENU_9_1_3',
          icon: { name: 'wrench', color: '' },
          link: '/proposal-subproject/manage-evaluation-team-role',
          children: 'จัดการสิทธิ์ทีมประเมินผล',
          param: '',
          paramName: '',
          isDisabled: false,
          viewMode: false,
          feedback: false,
        },
        {
          eventKey: 'ROLE_MANAGE_MENU_9_1_4',
          icon: { name: 'wrench', color: '' },
          link: '/proposal-subproject/search-for-names',
          children: 'ค้นหารายชื่อ',
          param: '',
          paramName: '',
          isDisabled: false,
          viewMode: false,
          feedback: false,
        },
      ],
      haveEndSectionLine: false,
      fixedMenu: true,
      titleItem: {
        eventKey: 'ROLE_MANAGE_MENU',
        placement: 'rightStart',
        title: 'จัดการสิทธิ์',
        icon: 'cog',
      },
    },
  ],
}

export const subProjectSchema = {
  alwaysOpenKeys: [],
  menu: menuType.subProject,
  sidebars: [
    {
      id: 'section1',
      type: 'nav',
      items: [
        {
          eventKey: '1',
          icon: {
            name: 'dashboard',
            color: '#2da888',
          },
          link: pathname.subProject.overviewSubProject,
          children: 'ภาพรวมข้อเสนอโครงการ',
        },
      ],
      haveEndSectionLine: true,
    },

    {
      id: 'section2',
      type: 'dropdown',
      titleItem: {
        eventKey: '2',
        placement: 'rightStart',
        title: 'กลั่นกรองทางวิชาการ',
        icon: 'filter',
      },
      items: [
        {
          eventKey: '2-0',
          icon: {
            name: 'check-circle',
          },
          link: pathname.subProject.reviewSubproject.saveReviewSubproject,
          children: 'บันทึกผลการพิจารณากลั่นกรอง และสรุปผล',
        },
        // {
        //   eventKey: '2-1',
        //   icon: {
        //     name: 'check-circle',
        //   },
        //   link: pathname.subProject.reviewSubproject.assignExpertSub,
        //   children: 'ขั้นที่ 1 เลือกผู้ทรงคุณวุฒิ',
        // },
        // {
        //   eventKey: '2-2',
        //   icon: {
        //     name: 'check-circle',
        //   },
        //   link: pathname.subProject.reviewSubproject.reviewSummarySub,
        //   children: 'ขั้นที่ 2 ผลการพิจารณากลั่นกรอง และสรุปผล',
        // },
        // {
        //   eventKey: '2-3',
        //   icon: {
        //     name: 'check-circle',
        //   },
        //   link: pathname.subProject.reviewSubproject.proposalReviseSub,
        //   children: 'ขั้นที่ 3 ส่งกลับผู้ขอรับทุนเพื่อปรับปรุงข้อเสนอ',
        // },
        {
          eventKey: '2-4',
          icon: {
            name: 'file-text-o',
          },
          link: pathname.subProject.reviewSubproject.paymentSaveSub,
          children: 'บันทึกงวดเงิน',
        },
      ],
    },
    {
      id: 'section3',
      type: 'dropdown',
      titleItem: {
        eventKey: '3',
        placement: 'rightStart',
        title: 'การพิจารณาอนุมัติโครงการ',
        icon: 'pencil',
      },
      items: [
        {
          eventKey: '3-1',
          icon: {
            name: 'check-circle',
          },
          link: pathname.subProject.approve.paymentCheckSubproject,
          param: '?1',
          children: 'ขั้นที่ 1 ตรวจสอบงวดเงิน',
        },
        {
          eventKey: '3-2',
          icon: {
            name: 'check-circle',
          },
          link: pathname.subProject.approve.granteeForStaffSubproject,
          param: '?2',
          children: 'ขั้นที่ 2 ตรวจสอบข้อมูลผู้รับทุน',
        },
        // {
        //   eventKey: '6-3',
        //   icon: {
        //     name: 'check-circle',
        //   },
        //   link: pathname.subProject.approve.sentToFixSubproject,
        //   param: '?3',
        //   children: 'ขั้นที่ 3 ส่งกลับเพื่อแก้ไข',
        // },
        {
          eventKey: '3-4',
          icon: {
            name: 'check-circle',
          },
          link: pathname.subProject.approve.subProjectApprovalSummaryForStaff,
          param: '?3',
          children: 'ขั้นที่ 3 สรุปผลการพิจารณาอนุมัติโครงการ',
        },
      ],
    },
    // {
    //   id: 'section3',
    //   type: 'dropdown',
    //   titleItem: {
    //     eventKey: '3',
    //     placement: 'rightStart',
    //     title: 'รายงานความก้าวหน้า',
    //     icon: 'file-text-o',
    //   },
    //   items: [
    //     {
    //       eventKey: '3-1',
    //       icon: {
    //         name: 'check-circle',
    //       },
    //       link: pathname.subProject.projectManagement.progressReportSubproject,
    //       param: '?565E16D3-4231-40E9-98E3-0030D18DB2A5',
    //       children: 'ครั้งที่ 1',
    //     },
    //     {
    //       eventKey: '3-2',
    //       icon: {
    //         name: 'check-circle',
    //       },
    //       link: pathname.subProject.projectManagement.progressReportSubproject,
    //       param: '?30EA7D6F-E32A-42F6-8B3F-B13F7CBDACD0',
    //       children: 'ครั้งที่ 2',
    //     },
    //     // {
    //     //   eventKey: '3-3',
    //     //   icon: {
    //     //     name: 'check-circle',
    //     //   },
    //     //   link: pathname.subProject.projectManagement.progressReportSubproject,
    //     //   param: '?1C15CA90-D25B-40FB-9858-DC8BE0AAE601',
    //     //   children: 'ครั้งที่ 3 (ครั้งสุดท้าย)',
    //     //   isDisabled: true,
    //     // },
    //   ],
    // },
    {
      id: 'section4',
      type: 'dropdown',
      titleItem: {
        eventKey: '4',
        placement: 'rightStart',
        title: 'ขอเบิกงวดเงิน',
        icon: 'file-text-o',
      },
      items: [
        {
          eventKey: '4-1',
          icon: {
            name: 'check-circle',
          },
          link: pathname.subProject.withdraw.withdrawRequestSubproject,
          param: '?DE5C9672-735C-41EF-8BBC-D2CC7CC62CF9',
          children: 'ขอเบิกงวดที่ 1',
          // isDisabled: true,
        },
        {
          eventKey: '4-2',
          icon: {
            name: 'check-circle',
          },
          link: pathname.subProject.withdraw.withdrawRequestSubproject,
          param: '?476973AD-3501-43D6-B3CB-AE95D3EEEA27',
          children: 'ขอเบิกงวดที่ 2',
          // isDisabled: true,
        },
        // {
        //   eventKey: '7-3',
        //   icon: {
        //     name: 'check-circle',
        //   },
        //   link: pathname.subProject.withdraw.withdrawRequestSubproject,
        //   param: '?projectProgressId3',
        //   children: 'ขอเบิกงวดที่ 3',
        //   isDisabled: true,
        // },
      ],
    },
    {
      id: 'section5',
      type: 'dropdown',
      titleItem: {
        eventKey: '5',
        placement: 'rightStart',
        title: '1. ข้อมูลทั่วไปของโครงการ',
        icon: 'file-o',
        color: '#2da888',
      },
      items: [
        {
          eventKey: '5-1',
          icon: {
            name: 'check-circle',
          },
          link: pathname.subProject.subProjectTypeInfo,
          children: '1.1 ลักษณะ ประเภทข้อเสนอ และระยะเวลาดำเนินโครงการ',
        },
        {
          eventKey: '5-2',
          icon: {
            name: 'check-circle',
          },
          link: pathname.subProject.targetSettingSubProject,
          children: '1.2 กลุ่มเป้าหมายดำเนินการ ประเด็น และพื้นที่ดำเนินการ',
        },
      ],
    },
    {
      id: 'section6',
      type: 'dropdown',
      titleItem: {
        eventKey: '6',
        placement: 'rightStart',
        title: '2. ข้อเสนอโครงการ',
        icon: 'file-text-o',
        color: '#2da888',
      },
      items: [
        {
          eventKey: '6-1',
          icon: {
            name: 'check-circle',
          },
          link: pathname.subProject.subProjectName,
          children: '2.1 ชื่อโครงการย่อย',
        },
        {
          eventKey: '6-3',
          icon: {
            name: 'check-circle',
          },
          link: pathname.subProject.objectiveGoalSub,
          children: '2.2 วัตถุประสงค์',
        },
        {
          eventKey: '6-4',
          icon: {
            name: 'check-circle',
          },
          link: pathname.subProject.budgetSubProject,
          children: '2.3 กิจกรรม และงบประมาณ',
        },
      ],
    },
    {
      id: 'section7',
      type: 'dropdown',
      titleItem: {
        eventKey: '7',
        placement: 'rightStart',
        title: '3. ผู้รับทุน ผู้รับผิดชอบโครงการ',
        icon: 'avatar',
        color: '#2da888',
      },
      items: [
        {
          eventKey: '7-1',
          icon: {
            name: 'check-circle',
          },
          link: pathname.subProject.granteeBasicInfoSub,
          children: '3.1 ผู้รับทุน',
        },
        {
          eventKey: '7-2',
          icon: {
            name: 'check-circle',
          },
          link: pathname.subProject.responsibleManBasicInfoSub,
          children: '3.2 ผู้รับผิดชอบโครงการ',
          // isDisabled: true,
        },
      ],
      haveEndSectionLine: true,
    },
    {
      id: 'section8',
      type: 'nav',
      items: [
        {
          eventKey: '8',
          icon: {
            name: 'pencil',
          },
          link: pathname.subProject.contract,
          children: 'พิมพ์สัญญา/แนบสัญญาที่ลงนามแล้ว',
        },
      ],
      haveEndSectionLine: true,
    },
    {
      id: 'section10',
      type: 'nav',
      items: [
        {
          eventKey: '10',
          icon: {
            name: 'file-text-o',
          },
          link: pathname.subProject.closeProject,
          children: 'ปิดโครงการ',
        },
      ],
      haveEndSectionLine: true,
    },
    // {
    //   id: 'section9',
    //   type: 'nav',
    //   items: [
    //     {
    //       eventKey: '9',
    //       icon: {
    //         name: 'gear',
    //       },
    //       link: pathname.subProject.setting.reportSetting,
    //       children: 'ตั้งค่าการใช้งาน',
    //     },
    //   ],
    //   haveEndSectionLine: true,
    // },
    {
      id: 'section9',
      type: 'dropdown',
      titleItem: {
        eventKey: '9',
        placement: 'rightStart',
        title: 'ตั้งค่าการใช้งาน',
        icon: 'gear',
      },
      items: [
        // {
        //   eventKey: '9-7',
        //   icon: {
        //     name: 'user',
        //   },
        //   link: pathname.subProject.users.usersRole,
        //   children: 'User role',
        // },
        {
          eventKey: '9-7',
          icon: {
            name: 'user',
          },
          link: pathname.subProject.users.createUser,
          children: 'เพิ่มผู้ใช้งาน',
        },
        {
          eventKey: '9-1',
          icon: {
            name: 'gear',
          },
          link: pathname.subProject.setting.reportSetting,
          children: 'ตั้งค่ารายงาน',
        },
      ],
      haveEndSectionLine: true,
    },
    {
      id: 'section10',
      type: 'dropdown',
      titleItem: {
        eventKey: '10',
        placement: 'rightStart',
        title: 'รายงาน',
        icon: 'file-text-o',
      },
      items: [
        {
          eventKey: '10-1',
          icon: {
            name: 'paste',
          },
          link: pathname.subProject.report.approvalFormReport,
          children: '1. แบบขออนุมัติโครงการ',
        },
        {
          eventKey: '10-2',
          icon: {
            name: 'paste',
          },
          link: pathname.subProject.report.summaryReport,
          children: '2. รายงานสรุปเพื่อขออนุมัติ',
        },
        {
          eventKey: '10-3',
          icon: {
            name: 'paste',
          },
          link: pathname.subProject.report.grantReport,
          children: '3. สัญญารับทุน',
        },
        {
          eventKey: '10-4',
          icon: {
            name: 'paste',
          },
          link: pathname.subProject.report.billPaymentReport,
          children: '4. ใบเบิกเงินโครงการย่อย',
        },
        {
          eventKey: '10-5',
          icon: {
            name: 'paste',
          },
          link: pathname.subProject.report.subProjectApprovalReport,
          children: '5. ขออนุมัติปิดโครงการย่อย',
        },
        {
          eventKey: '10-6',
          icon: {
            name: 'paste',
          },
          link: pathname.subProject.report.progressiveReport,
          children: '6. แบบรายงานความก้าวหน้าโครงการ',
        },
        {
          eventKey: '10-7',
          icon: {
            name: 'paste',
          },
          link: pathname.subProject.report.projectControlReport,
          children: '7. ทะเบียนควบคุมโครงการ',
        },
        {
          eventKey: '10-8',
          icon: {
            name: 'paste',
          },
          link: pathname.subProject.report.subProjectReport,
          children: '8. รายงานโครงการย่อย',
        },
      ],
      haveEndSectionLine: true,
    },
  ],
}
